var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGooglePlayImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 53,
    viewBox: "0 0 181 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M173.833 52.5H7.16667C3.50167 52.5 0.5 49.5734 0.5 46V7C0.5 3.42663 3.50167 0.500003 7.16667 0.500003H173.833C177.498 0.500003 180.5 3.42663 180.5 7V46C180.5 49.5734 177.498 52.5 173.833 52.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M173.833 1.54162C176.92 1.54162 179.432 3.9905 179.432 7V46C179.432 49.0095 176.92 51.4584 173.833 51.4584H7.16667C4.08 51.4584 1.56833 49.0095 1.56833 46V7C1.56833 3.9905 4.08 1.54162 7.16667 1.54162H173.833ZM173.833 0.500003H7.16667C3.50167 0.500003 0.5 3.42663 0.5 7V46C0.5 49.5734 3.50167 52.5 7.16667 52.5H173.833C177.498 52.5 180.5 49.5734 180.5 46V7C180.5 3.42663 177.498 0.500003 173.833 0.500003Z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4133 10.3004C14.0216 10.7002 13.7949 11.3226 13.7949 12.1286V40.8781C13.7949 41.6841 14.0216 42.3064 14.4133 42.7062L14.5099 42.7939L31.0332 26.6902V26.3099L14.5099 10.2062L14.4133 10.3004Z",
    fill: "url(#paint0_linear_525_6463)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5349 32.0608L31.0332 26.6902V26.3099L36.5415 20.9393L36.6649 21.0092L43.1882 24.628C45.0499 25.655 45.0499 27.345 43.1882 28.3785L36.6649 31.9909L36.5349 32.0608Z",
    fill: "url(#paint1_linear_525_6463)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6657 31.991L31.0341 26.5001L14.4141 42.7062C15.0324 43.34 16.0407 43.4163 17.1874 42.7826L36.6657 31.991Z",
    fill: "url(#paint2_linear_525_6463)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6657 21.0091L17.1874 10.2175C16.0407 9.59025 15.0324 9.66663 14.4141 10.3004L31.0341 26.5L36.6657 21.0091Z",
    fill: "url(#paint3_linear_525_6463)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7234 13.8169C63.7234 14.9024 63.3901 15.7718 62.7334 16.4202C61.9784 17.1888 60.9951 17.5756 59.7901 17.5756C58.6384 17.5756 57.655 17.1823 56.8484 16.4072C56.04 15.6207 55.6367 14.6554 55.6367 13.5001C55.6367 12.3447 56.04 11.3794 56.8484 10.5994C57.655 9.81781 58.6384 9.42456 59.7901 9.42456C60.3634 9.42456 60.91 9.53994 61.4317 9.75444C61.9517 9.97056 62.375 10.2631 62.6817 10.6238L61.9851 11.3096C61.45 10.6937 60.7217 10.3898 59.7901 10.3898C58.9501 10.3898 58.2217 10.6758 57.6034 11.2527C56.9917 11.8312 56.685 12.5803 56.685 13.5001C56.685 14.4198 56.9917 15.1754 57.6034 15.7539C58.2217 16.3243 58.9501 16.6168 59.7901 16.6168C60.6817 16.6168 61.4317 16.3243 62.0234 15.7474C62.4134 15.3656 62.6351 14.8391 62.6934 14.1663H59.7901V13.2271H63.6634C63.7101 13.4302 63.7234 13.6268 63.7234 13.8169Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8676 10.5604H66.2292V13.0304H69.5092V13.9696H66.2292V16.4396H69.8676V17.3968H65.1992V9.60327H69.8676V10.5604Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M74.205 17.3968H73.175V10.5604H70.9434V9.60327H76.4384V10.5604H74.205V17.3968Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M80.416 17.3968V9.60327H81.4444V17.3968H80.416Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0019 17.3968H84.9802V10.5604H82.7402V9.60327H88.2419V10.5604H86.0019V17.3968Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6446 16.3942C97.8563 17.1823 96.8796 17.5756 95.7146 17.5756C94.5429 17.5756 93.5663 17.1823 92.7779 16.3942C91.9913 15.6077 91.5996 14.6424 91.5996 13.5001C91.5996 12.3577 91.9913 11.3924 92.7779 10.6059C93.5663 9.81781 94.5429 9.42456 95.7146 9.42456C96.8729 9.42456 97.8496 9.81781 98.638 10.6124C99.4313 11.4054 99.8229 12.3642 99.8229 13.5001C99.8229 14.6424 99.4313 15.6077 98.6446 16.3942ZM93.5396 15.7409C94.1329 16.3243 94.8546 16.6168 95.7146 16.6168C96.5679 16.6168 97.2963 16.3243 97.8829 15.7409C98.4746 15.1576 98.7746 14.4084 98.7746 13.5001C98.7746 12.5917 98.4746 11.8426 97.8829 11.2592C97.2963 10.6758 96.5679 10.3833 95.7146 10.3833C94.8546 10.3833 94.1329 10.6758 93.5396 11.2592C92.9479 11.8426 92.6479 12.5917 92.6479 13.5001C92.6479 14.4084 92.9479 15.1576 93.5396 15.7409Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M101.268 17.3968V9.60327H102.518L106.404 15.6645H106.449L106.404 14.1663V9.60327H107.433V17.3968H106.359L102.289 11.0365H102.244L102.289 12.5413V17.3968H101.268Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3474 28.7783C88.2157 28.7783 85.6574 31.102 85.6574 34.3082C85.6574 37.4883 88.2157 39.8364 91.3474 39.8364C94.4857 39.8364 97.044 37.4883 97.044 34.3082C97.044 31.102 94.4857 28.7783 91.3474 28.7783ZM91.3474 37.6589C89.629 37.6589 88.1507 36.276 88.1507 34.3082C88.1507 32.3143 89.629 30.9558 91.3474 30.9558C93.0657 30.9558 94.5507 32.3143 94.5507 34.3082C94.5507 36.276 93.0657 37.6589 91.3474 37.6589ZM78.9324 28.7783C75.794 28.7783 73.2424 31.102 73.2424 34.3082C73.2424 37.4883 75.794 39.8364 78.9324 39.8364C82.069 39.8364 84.6224 37.4883 84.6224 34.3082C84.6224 31.102 82.069 28.7783 78.9324 28.7783ZM78.9324 37.6589C77.2124 37.6589 75.729 36.276 75.729 34.3082C75.729 32.3143 77.2124 30.9558 78.9324 30.9558C80.6507 30.9558 82.129 32.3143 82.129 34.3082C82.129 36.276 80.6507 37.6589 78.9324 37.6589ZM64.159 30.4732V32.8229H69.914C69.7457 34.1359 69.2957 35.1012 68.6057 35.7739C67.7657 36.5864 66.4574 37.4883 64.159 37.4883C60.6174 37.4883 57.844 34.7014 57.844 31.2483C57.844 27.7952 60.6174 25.0083 64.159 25.0083C66.074 25.0083 67.4674 25.7379 68.4957 26.6837L70.194 25.0278C68.7557 23.6888 66.8424 22.6602 64.159 22.6602C59.3024 22.6602 55.2207 26.513 55.2207 31.2483C55.2207 35.9835 59.3024 39.8364 64.159 39.8364C66.784 39.8364 68.7557 38.9979 70.3057 37.4249C71.894 35.8763 72.389 33.6988 72.389 31.9405C72.389 31.3945 72.3424 30.8924 72.259 30.4732H64.159ZM124.569 32.2948C124.101 31.0582 122.656 28.7783 119.712 28.7783C116.796 28.7783 114.367 31.0192 114.367 34.3082C114.367 37.4054 116.771 39.8364 119.992 39.8364C122.597 39.8364 124.101 38.2878 124.719 37.3859L122.786 36.1298C122.141 37.0495 121.262 37.6589 119.992 37.6589C118.731 37.6589 117.826 37.095 117.246 35.9835L124.831 32.9237L124.569 32.2948ZM116.836 34.1359C116.771 32.0039 118.534 30.9119 119.797 30.9119C120.787 30.9119 121.627 31.3945 121.907 32.0852L116.836 34.1359ZM110.671 39.5H113.164V23.25H110.671V39.5ZM106.587 30.01H106.504C105.944 29.3633 104.876 28.7783 103.522 28.7783C100.682 28.7783 98.0857 31.2093 98.0857 34.326C98.0857 37.4249 100.682 39.8364 103.522 39.8364C104.876 39.8364 105.944 39.2465 106.504 38.5803H106.587V39.3733C106.587 41.4874 105.429 42.6233 103.561 42.6233C102.037 42.6233 101.092 41.5508 100.702 40.6489L98.534 41.5313C99.159 42.997 100.814 44.8008 103.561 44.8008C106.484 44.8008 108.951 43.1238 108.951 39.0434V29.1147H106.587V30.01ZM103.736 37.6589C102.017 37.6589 100.579 36.2565 100.579 34.326C100.579 32.3777 102.017 30.9558 103.736 30.9558C105.429 30.9558 106.764 32.3777 106.764 34.326C106.764 36.2565 105.429 37.6589 103.736 37.6589ZM136.242 23.25H130.279V39.5H132.766V33.3429H136.242C139.004 33.3429 141.712 31.3945 141.712 28.2957C141.712 25.1984 138.997 23.25 136.242 23.25ZM136.307 31.0825H132.766V25.5104H136.307C138.164 25.5104 139.224 27.0135 139.224 28.2957C139.224 29.5534 138.164 31.0825 136.307 31.0825ZM151.679 28.7474C149.882 28.7474 148.014 29.5209 147.246 31.2353L149.452 32.1372C149.927 31.2353 150.801 30.9428 151.724 30.9428C153.014 30.9428 154.322 31.6984 154.342 33.0325V33.2032C153.892 32.9497 152.929 32.5743 151.744 32.5743C149.367 32.5743 146.946 33.8499 146.946 36.2305C146.946 38.408 148.892 39.8104 151.081 39.8104C152.754 39.8104 153.677 39.0743 154.257 38.2179H154.342V39.474H156.744V33.2405C156.744 30.3594 154.537 28.7474 151.679 28.7474ZM151.379 37.6524C150.566 37.6524 149.432 37.2592 149.432 36.276C149.432 35.0183 150.846 34.5357 152.069 34.5357C153.164 34.5357 153.677 34.7713 154.342 35.0817C154.147 36.5864 152.819 37.6524 151.379 37.6524ZM165.494 29.1033L162.636 36.1477H162.551L159.596 29.1033H156.914L161.354 38.9475L158.821 44.4254H161.419L168.261 29.1033H165.494ZM143.079 39.5H145.572V23.25H143.079V39.5Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_525_6463",
    x1: 29.5662,
    y1: 41.1775,
    x2: 7.75605,
    y2: 18.8081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_525_6463",
    x1: 45.6124,
    y1: 26.4982,
    x2: 13.3499,
    y2: 26.4982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_525_6463",
    x1: 33.6034,
    y1: 23.5152,
    x2: 4.02709,
    y2: -6.81951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_525_6463",
    x1: 10.2305,
    y1: 52.2709,
    x2: 23.4376,
    y2: 38.7253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayImg);
export default __webpack_public_path__ + "static/media/google-play-img.a202c0958d8f6968b98b32b05318aeca.svg";
export { ForwardRef as ReactComponent };